import React from 'react'
import StyledDiv from './styles'
import { Button, Modal } from '../../../components'
import { IPaymentState } from '../../../models'
import { LiteralsService } from '../../../services'

interface IProps {
  visible: boolean
  paymentState: IPaymentState
  isRefund: boolean
  close: () => void
  confirmPayment: () => void
}

export const ConfirmPaymentModal: React.FC<IProps> = ({
  visible,
  paymentState,
  isRefund,
  close,
  confirmPayment
}) => {

  const modalContent = () => {
    return (
      <StyledDiv>
        <header>
          <h3> { LiteralsService.get( isRefund ? 'confirmRefundTitle' : 'confirmPaymentTitle', true ) } </h3>
        </header>
        <section>
            <Button 
              title={ LiteralsService.get('confirm', true) }
              onPress={ confirmPayment }
              isDisabled={ paymentState === IPaymentState.DOING_PAYMENT }
              filled
              upper
            />
            <Button 
              title={ LiteralsService.get('cancel', true) }
              onPress={ close }
              isDisabled={ paymentState === IPaymentState.DOING_PAYMENT }
              upper
            />
        </section>
      </StyledDiv>
    )
  }

  if (!visible) return null
  return (
    <Modal className='small' onOverlayClick={ close } >
      { modalContent() }
    </Modal>
  )

}